import { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useGetData } from "../../../../../hooks/useGetData";
import { useMutationData } from "../../../../../hooks/useMutationData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { ConclusionVDInterface } from "../../../../../interfaces/ConclusionVDInterface";
import { AutomovilesBienes } from "../../../../../interfaces/AutomovilesBienesInterface";
import { BienesRaices } from "../../../../../interfaces/BienesRaicesInterface";
import { SituacionInmuebleInterface } from "../../../../../interfaces/SituacionInmuebleInterface";
import { ZonaInterface } from "../../../../../interfaces/ZonaInterface";
import { NotasBienes } from "../../../../../interfaces/NotasBienesInterface";
import { InteriorInmuebleInterface } from "../../../../../interfaces/InteriorInmuebleInterface";
import { NotasInmuebleCasaInterface } from "../../../../../interfaces/NotasInmuebleCasaInterface";
import { ZonaInmuebleCasaInterface } from "../../../../../interfaces/ZonaInmuebleCasaInterface";
import { EspacioInmuebleCasaInterface } from "../../../../../interfaces/EspacioInmuebleCasaInterface";
import { ServiciosInmuebleCasaInterface } from "../../../../../interfaces/ServiciosInmuebleCasaInterface";
import { PadresHermanosInterface } from "../../../../../interfaces/PadresHermanosInterface";
import { ConyugeInterface } from "../../../../../interfaces/ConyugeInterface";
import { HijosInterface } from "../../../../../interfaces/HijosInterface";
import { NotasInfofamInterface } from "../../../../../interfaces/NotasInfofamInterface";
import { ReferenciasLaboralesInterface } from "../../../../../interfaces/ReferenciasLaboralesInterface";
import { ReferenciasPersonalesInterface } from "../../../../../interfaces/ReferenciasPersonalesInterface";
import { ReferenciasVecinalesInterface } from "../../../../../interfaces/ReferenciasVecinalesInterface";
import { FechasInterface } from "../../../../../interfaces/FechasInterface";
import { SemaforoVDInterface } from "../../../../../interfaces/SemaforoVDInterface";
import { Loading } from "../../../../../components/Loading/Loading";
import { Checkbox, Label, Textarea, TextInput } from "flowbite-react";
import { Button } from "flowbite-react";
import { API } from "../../../../../global/global";
import Semaforo from "../../../../../img/Semaforo.png";
import Rojo from "../../../../../img/Rojo.png";
import Amarillo from "../../../../../img/Amarillo.png";
import Verde from "../../../../../img/Verde.png";
import Header from "../../../../../components/HeaderForms/HeaderForms";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";

export const ConclusionesDomEditarScreen = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const tituloFormulario = "CONCLUSIONES DE EVALUACIÓN DE VISITA DOMICILIARIA";
  const { control, reset, setValue, handleSubmit } = useForm();
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [images, setImages] = useState<string[]>([""]);
  const [notes, setNotes] = useState<string[]>([]);
  const [fechaNacimiento, setFechaNacimiento] = useState<string>("");
  const [edad, setEdad] = useState<number | null>(null);
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);
  const [photoUrl2, setPhotoUrl2] = useState<string | null>(null);
  const [selectedValue, setSelectedValue] = useState<string>("");

  const [formData, setFormData] = useState({
    visitDate: "",
    name: "",
  });

  const [zonasSeleccionadas, setZonasSeleccionadas] = useState<{
    sala: boolean;
    cocina: boolean;
    recamaras: boolean;
    cochera: boolean;
    lavado: boolean;
    baniosCompletos: boolean;
    mediosBanios: boolean;
    jaula: boolean;
    balcones: boolean;
    patios: boolean;
  }>({
    sala: false,
    cocina: false,
    recamaras: false,
    cochera: false,
    lavado: false,
    baniosCompletos: false,
    mediosBanios: false,
    jaula: false,
    balcones: false,
    patios: false,
  });

  const [serviciosSeleccionados, setServiciosSeleccionados] = useState<{
    agua: boolean;
    drenaje: boolean;
    transporte: boolean;
    vigilancia: boolean;
    telefono: boolean;
    luz: boolean;
    pavimentacion: boolean;
  }>({
    agua: false,
    drenaje: false,
    transporte: false,
    vigilancia: false,
    telefono: false,
    luz: false,
    pavimentacion: false,
  });

  const calcularEdad = (fechaNacimiento: string) => {
    const fechaNac = new Date(fechaNacimiento);
    const hoy = new Date();
    let edadCalculada = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edadCalculada--;
    }

    return edadCalculada;
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    const updatedFormData = { ...formData, [name]: value };
    setFormData(updatedFormData);

    localStorage.setItem("formData", JSON.stringify(updatedFormData));
  };

  const handlePageChange = (newPage: number) => {
    const filledImages = images.filter((image) => image);
    setImages(filledImages.length > 0 ? filledImages : [""]);
    setCurrentPage(newPage);
  };

  useEffect(() => {
    const savedFormData = localStorage.getItem("formData");
    const savedZones = localStorage.getItem("selectedZones");
    if (savedFormData) {
      setFormData(JSON.parse(savedFormData));
    }

    const savedImages = localStorage.getItem("images");
    if (savedImages) {
      setImages(JSON.parse(savedImages));
    }
  }, []);

  const resetFormData = () => {
    const emptyFormData = {
      visitDate: "",
      name: "",
      rfc: "",
      sex: "",
      civilStatus: "",
      education: "",
      birthDate: "",
      curp: "",
      company: "",
    };
    setImages([""]);
    localStorage.removeItem("images");
  };

  const handleImageChange = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const newImages = [...images];
        newImages[index] = reader.result as string;
        setImages(newImages);

        localStorage.setItem("images", JSON.stringify(newImages));
      };
      reader.readAsDataURL(file);
    }
  };

  const addImageBox = () => {
    setImages([...images, ""]);
    setNotes([...notes, ""]);
  };

  const removeImage = (index: number) => {
    const updatedImages = images.filter((_, i) => i !== index);
    const updatedNotes = notes.filter((_, i) => i !== index);
    setImages(updatedImages);
    setNotes(updatedNotes);
  };

  const renderHeader = () => (
    <>
      {/* Header */}
      <Header titulo={tituloFormulario} />
    </>
  );

  const handleNoteChange = (
    index: number,
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    const updatedNotes = [...notes];
    updatedNotes[index] = event.target.value;
    setNotes(updatedNotes);
  };

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const mutateConclusionVD = useMutationData({
    url: `/conclusionVD/${evaluadosList_id}`,
    reload: ["evaluado", "conclusionVD", `${evaluadosList_id}`],
  });

  const queryConclusionVD = useGetData<ConclusionVDInterface[]>({
    url: `/conclusionVD/${evaluadosList_id}`,
    name: ["conclusionVD"],
  });

  const queryAuto = useGetData<AutomovilesBienes[]>({
    url: `/autobienes/${evaluadosList_id}`,
    name: ["autobienes"],
  });

  const queryBienesRaices = useGetData<BienesRaices[]>({
    url: `/bienesraices/${evaluadosList_id}`,
    name: ["bienesraices"],
  });

  const querySituacionInmueble = useGetData<SituacionInmuebleInterface[]>({
    url: `/situacion-inmueble/${evaluadosList_id}`,
    name: ["situacion-inmueble"],
  });

  const queryZonaInmueble = useGetData<ZonaInterface[]>({
    url: `/zona-inmueble/${evaluadosList_id}`,
    name: ["zona-inmueble"],
  });

  const queryNotasBienes = useGetData<NotasBienes[]>({
    url: `/notas-bienes-inmuebles/${evaluadosList_id}`,
    name: ["notas-bienes-inmuebles"],
  });

  const queryInteriorInmueble = useGetData<InteriorInmuebleInterface[]>({
    url: `/interior-inmueble/${evaluadosList_id}`,
    name: ["interior-inmueble"],
  });

  const queryNotasInmueble = useGetData<NotasInmuebleCasaInterface[]>({
    url: `/notas-inmueblecasa/${evaluadosList_id}`,
    name: ["notas-inmueblecasa"],
  });

  const queryZonadosInmueble = useGetData<ZonaInmuebleCasaInterface[]>({
    url: `/zonas_inmueblecasa/${evaluadosList_id}`,
    name: ["zonas_inmueblecasa"],
  });

  const queryEspacioInmueble = useGetData<EspacioInmuebleCasaInterface[]>({
    url: `/espacio-inmueblecasa/${evaluadosList_id}`,
    name: ["espacio-inmueblecasa"],
  });

  const queryServiciosInmueble = useGetData<ServiciosInmuebleCasaInterface[]>({
    url: `/servicios-inmueblecasa/${evaluadosList_id}`,
    name: ["servicios-inmueblecasa"],
  });

  const queryPadresHermanos = useGetData<PadresHermanosInterface[]>({
    url: `/padres-hermanos/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "padres-hermanos"],
  });

  const queryConyuge = useGetData<ConyugeInterface[]>({
    url: `/conyuge/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "conyuge"],
  });

  const queryHijos = useGetData<HijosInterface>({
    url: `/hijos/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "hijos"],
  });

  const queryNotasInfoFam = useGetData<NotasInfofamInterface[]>({
    url: `/notas_infofam/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "notas_infofam"],
  });

  const queryLaborales = useGetData<ReferenciasLaboralesInterface>({
    url: `/referencia-laboral/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "referencia-laboral"],
  });

  const queryPersonales = useGetData<ReferenciasPersonalesInterface>({
    url: `/referencia_personal/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "referencia_personal"],
  });

  const queryVecinales = useGetData<ReferenciasVecinalesInterface>({
    url: `/referencia_vecinal/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "referencia_vecinal"],
  });

  const queryFecha = useGetData<FechasInterface[]>({
    url: `/evaluado/${evaluadosList_id}/fecha-visita-bienesinmuebles`,
    name: ["fecha-visita-bienesinmuebles"],
  });

  const mutateFecha = useMutationData({
    url: `/evaluado/${evaluadosList_id}/fecha-visita-bienesinmuebles`,
    reload: ["evaluado", `${evaluadosList_id}`, "fecha-visita-bienesinmuebles"],
  });

  const querySemaforoVD = useGetData<SemaforoVDInterface>({
    url: `/semaforoVD/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "semaforoVD"],
  });

  const mutateSemaforoVD = useMutationData({
    url: `/semaforoVD/${evaluadosList_id}`,
    reload: ["evaluado", "semaforoVD", `${evaluadosList_id}`],
  });

  const normalizeString = (str: string) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const nombreCompleto = normalizeString(
    `${queryEvaluado.data?.nombre}_${queryEvaluado.data?.apellido_paterno}_${queryEvaluado.data?.apellido_materno}`.replace(
      /\s/g,
      "_"
    )
  );

  const [selectedImage, setSelectedImage] = useState(Semaforo);
  const [selectedRecommendation, setSelectedRecommendation] = useState<
    string | null
  >(null);

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSelectedRecommendation(value);

    if (value === "recomendable") {
      setSelectedImage(Verde);
    } else if (value === "con_reserva") {
      setSelectedImage(Amarillo);
    } else if (value === "no_recomendable") {
      setSelectedImage(Rojo);
    }
  };

  useEffect(() => {
    if (selectedRecommendation === "recomendable") {
      setSelectedValue("RECOMENDABLE");
    } else if (selectedRecommendation === "con_reserva") {
      setSelectedValue("CON RESERVA");
    } else if (selectedRecommendation === "no_recomendable") {
      setSelectedValue("NO RECOMENDABLE");
    }
  }, [selectedRecommendation]);

  useEffect(() => {
    if (queryEvaluado.data) {
      const fechaNac = queryEvaluado.data.fecha_nacimiento || "";
      setFechaNacimiento(fechaNac);

      const nuevaEdad = calcularEdad(fechaNac);
      console.log("Fecha de nacimiento:", fechaNac);
      console.log("Edad calculada:", nuevaEdad);
      setEdad(nuevaEdad);

      reset({
        nombre: queryEvaluado.data.nombre || "",
        apellido_paterno: queryEvaluado.data.apellido_paterno || "",
        apellido_materno: queryEvaluado.data.apellido_materno || "",
        rfc: queryEvaluado.data.rfc || "",
        genero: queryEvaluado.data.genero || "",
        estado_civil: queryEvaluado.data.estado_civil || "",
        escolaridad: queryEvaluado.data.escolaridad || "",
        fecha_nacimiento: fechaNac,
        curp: queryEvaluado.data.curp || "",
        empresa: queryEvaluado.data.empresa?.nombre || "",
      });
    }
  }, [queryEvaluado.data, reset]);

  useEffect(() => {
    if (queryConclusionVD.data && queryConclusionVD.data.length > 0) {
      const conclusion = queryConclusionVD.data[0];
      reset({
        nota_conclusionvd1: conclusion.nota_conclusionvd1 || "",
        resultado1: conclusion.resultado1 || "",
        resultado2: conclusion.resultado2 || "",
        detecto_vd: conclusion.detecto_vd || "",
        entrevisto_vd: conclusion.entrevisto_vd || "",
      });
    }
  }, [queryConclusionVD.data, reset]);

  useEffect(() => {
    console.log("queryAuto.data:", queryAuto.data);
    if (queryAuto.data && queryAuto.data.length > 0) {
      const auto = queryAuto.data[0];
      reset({
        marca_autobienes1: auto.marca_autobienes1 || "",
        modelo_autobienes1: auto.modelo_autobienes1 || "",
        precio_autobienes1: auto.precio_autobienes1 || "",
        liquidado_nombre_autobienes1: auto.liquidado_nombre_autobienes1 || "",
        marca_autobienes2: auto.marca_autobienes2 || "",
        modelo_autobienes2: auto.modelo_autobienes2 || "",
        precio_autobienes2: auto.precio_autobienes2 || "",
        liquidado_nombre_autobienes2: auto.liquidado_nombre_autobienes2 || "",
        marca_autobienes3: auto.marca_autobienes3 || "",
        modelo_autobienes3: auto.modelo_autobienes3 || "",
        precio_autobienes3: auto.precio_autobienes3 || "",
        liquidado_nombre_autobienes3: auto.liquidado_nombre_autobienes3 || "",
        marca_autobienes4: auto.marca_autobienes4 || "",
        modelo_autobienes4: auto.modelo_autobienes4 || "",
        precio_autobienes4: auto.precio_autobienes4 || "",
        liquidado_nombre_autobienes4: auto.liquidado_nombre_autobienes4 || "",
        marca_autobienes5: auto.marca_autobienes5 || "",
        modelo_autobienes5: auto.modelo_autobienes5 || "",
        precio_autobienes5: auto.precio_autobienes5 || "",
        liquidado_nombre_autobienes5: auto.liquidado_nombre_autobienes5 || "",
      });
    }
  }, [queryAuto.data, reset]);

  useEffect(() => {
    console.log("queryBienesRaices.data:", queryBienesRaices.data);
    if (queryBienesRaices.data && queryBienesRaices.data.length > 0) {
      const bienes = queryBienesRaices.data[0];
      reset({
        tipo_bienes1: bienes.tipo_bienes1 || "",
        ubicacion_bienes1: bienes.ubicacion_bienes1 || "",
        precio_bienes1: bienes.precio_bienes1 || "",
        liquidado_nombre_bienes1: bienes.liquidado_nombre_bienes1 || "",
        tipo_bienes2: bienes.tipo_bienes2 || "",
        ubicacion_bienes2: bienes.ubicacion_bienes2 || "",
        precio_bienes2: bienes.precio_bienes2 || "",
        liquidado_nombre_bienes2: bienes.liquidado_nombre_bienes2 || "",
        tipo_bienes3: bienes.tipo_bienes3 || "",
        ubicacion_bienes3: bienes.ubicacion_bienes3 || "",
        precio_bienes3: bienes.precio_bienes3 || "",
        liquidado_nombre_bienes3: bienes.liquidado_nombre_bienes3 || "",
        tipo_bienes4: bienes.tipo_bienes4 || "",
        ubicacion_bienes4: bienes.ubicacion_bienes4 || "",
        precio_bienes4: bienes.precio_bienes4 || "",
        liquidado_nombre_bienes4: bienes.liquidado_nombre_bienes4 || "",
        tipo_bienes5: bienes.tipo_bienes5 || "",
        ubicacion_bienes5: bienes.ubicacion_bienes5 || "",
        precio_bienes5: bienes.precio_bienes5 || "",
        liquidado_nombre_bienes5: bienes.liquidado_nombre_bienes5 || "",
      });
    }
  }, [queryBienesRaices.data, reset]);

  useEffect(() => {
    if (querySituacionInmueble.data && querySituacionInmueble.data.length > 0) {
      const situacion = querySituacionInmueble.data[0];
      reset({
        situacion_del_inmueble: situacion.situacion_del_inmueble || "",
      });
    }
  }, [querySituacionInmueble.data, reset]);

  useEffect(() => {
    if (queryZonaInmueble.data && queryZonaInmueble.data.length > 0) {
      const zona = queryZonaInmueble.data[0];
      reset({
        zona_del_inmueble: zona.zona_del_inmueble || "",
      });
    }
  }, [queryZonaInmueble.data, reset]);

  useEffect(() => {
    if (queryNotasBienes.data && queryNotasBienes.data.length > 0) {
      const notas = queryNotasBienes.data[0];
      reset({
        nota_bienes1: notas.nota_bienes1 || "",
        nota_bienes2: notas.nota_bienes2 || "",
      });
    }
  }, [queryBienesRaices.data, reset]);

  useEffect(() => {
    if (queryInteriorInmueble.data && queryInteriorInmueble.data.length > 0) {
      const interior = queryInteriorInmueble.data[0];
      reset({
        orden: interior.orden || "",
        limpieza: interior.limpieza || "",
        mobiliario: interior.mobiliario || "",
        distribucion: interior.distribucion || "",
      });
    }
  }, [queryBienesRaices.data, reset]);

  useEffect(() => {
    if (queryNotasInmueble.data && queryNotasInmueble.data.length > 0) {
      const notas_in = queryNotasInmueble.data[0];
      reset({
        nota_inmueblecasa: notas_in.nota_inmueblecasa || "",
      });
    }
  }, [queryBienesRaices.data, reset]);

  useEffect(() => {
    if (
      queryZonadosInmueble.data &&
      Array.isArray(queryZonadosInmueble.data) &&
      queryZonadosInmueble.data.length > 0
    ) {
      const {
        sala_comedor,
        cocina,
        recamaras,
        cochera,
        area_lavado,
        banios_completos,
        medios_banios,
        jaula_tendido,
        balcones,
        patios,
      } = queryZonadosInmueble.data[0];

      setZonasSeleccionadas({
        sala: sala_comedor ?? false,
        cocina: cocina ?? false,
        recamaras: recamaras ?? false,
        cochera: cochera ?? false,
        lavado: area_lavado ?? false,
        baniosCompletos: banios_completos ?? false,
        mediosBanios: medios_banios ?? false,
        jaula: jaula_tendido ?? false,
        balcones: balcones ?? false,
        patios: patios ?? false,
      });
    }
  }, [queryZonadosInmueble.data]);

  useEffect(() => {
    if (
      queryServiciosInmueble.data &&
      Array.isArray(queryServiciosInmueble.data) &&
      queryServiciosInmueble.data.length > 0
    ) {
      const {
        agua,
        drenaje,
        transporte,
        vigilancia,
        telefono,
        luz,
        pavimentacion,
      } = queryServiciosInmueble.data[0];

      setServiciosSeleccionados({
        agua: agua ?? false,
        drenaje: drenaje ?? false,
        transporte: transporte ?? false,
        vigilancia: vigilancia ?? false,
        telefono: telefono ?? false,
        luz: luz ?? false,
        pavimentacion: pavimentacion ?? false,
      });
    }
  }, [queryServiciosInmueble.data]);

  useEffect(() => {
    if (queryPadresHermanos.data && queryPadresHermanos.data.length > 0) {
      const ph = queryPadresHermanos.data[0];
      reset({
        nombre_ph: ph.nombre_ph1 || "",
        parentesco_ph: ph.parentesco_ph1 || "",
        edad_ph: ph.edad_ph1 || "",
        estado_civilph: ph.estado_civilph1 || "",
        domicilio_ph: ph.domicilio_ph1 || "",
        vivecon_evaluadoph: ph.vivecon_evaluadoph1 || "",
        actividad_laboralph: ph.actividad_laboralph1 || "",
        ultimogrado_estudiosph: ph.ultimogrado_estudiosph1 || "",
      });
    }
  }, [queryPadresHermanos.data, reset]);

  useEffect(() => {
    if (queryConyuge.data && queryConyuge.data.length > 0) {
      const conyuge = queryConyuge.data[0];
      reset({
        nombrec: conyuge.nombrec || "",
        edadc: conyuge.edadc || "",
        domicilioc: conyuge.domicilioc || "",
        vivecon_evaluadoc: conyuge.vivecon_evaluadoc || "",
        actividad_laboralc: conyuge.actividad_laboralc || "",
        ultimogrado_estudiosc: conyuge.ultimogrado_estudiosc || "",
      });
    }
  }, [queryConyuge.data, reset]);

  useEffect(() => {
    if (queryHijos.data) {
      const hijo = queryHijos.data;
      reset({
        nombreh1: hijo.nombreh1 || "",
        edadh1: hijo.edadh1 || "",
        domicilioh1: hijo.domicilioh1 || "",
        vivecon_evaluadoh1: hijo.vivecon_evaluadoh1 || "",
        actividad_laboralh1: hijo.actividad_laboralh1 || "",
        ultimogrado_estudiosh1: hijo.ultimogrado_estudiosh1 || "",
        nombreh2: hijo.nombreh2 || "",
        edadh2: hijo.edadh2 || "",
        domicilioh2: hijo.domicilioh2 || "",
        vivecon_evaluadoh2: hijo.vivecon_evaluadoh2 || "",
        actividad_laboralh2: hijo.actividad_laboralh2 || "",
        ultimogrado_estudiosh2: hijo.ultimogrado_estudiosh2 || "",
        nombreh3: hijo.nombreh3 || "",
        edadh3: hijo.edadh3 || "",
        domicilioh3: hijo.domicilioh3 || "",
        vivecon_evaluadoh3: hijo.vivecon_evaluadoh3 || "",
        actividad_laboralh3: hijo.actividad_laboralh3 || "",
        ultimogrado_estudiosh3: hijo.ultimogrado_estudiosh3 || "",
        nombreh4: hijo.nombreh4 || "",
        edadh4: hijo.edadh4 || "",
        domicilioh4: hijo.domicilioh4 || "",
        vivecon_evaluadoh4: hijo.vivecon_evaluadoh4 || "",
        actividad_laboralh4: hijo.actividad_laboralh4 || "",
        ultimogrado_estudiosh4: hijo.ultimogrado_estudiosh4 || "",
      });
    }
  }, [queryHijos.data, reset]);

  useEffect(() => {
    if (queryNotasInfoFam.data && queryNotasInfoFam.data.length > 0) {
      const notasinfo = queryNotasInfoFam.data[0];
      reset({
        nota_ph: notasinfo.nota_ph || "",
        nota_c: notasinfo.nota_c || "",
        nota_h: notasinfo.nota_h || "",
        nota_f: notasinfo.nota_f || "",
      });
    }
  }, [queryNotasInfoFam.data, reset]);

  useEffect(() => {
    if (queryLaborales.data) {
      const rl = queryLaborales.data;
      reset({
        empresa_rl1: rl.empresa_rl1 || "",
        domicilio_rl1: rl.domicilio_rl1 || "",
        telefono_rl1: rl.telefono_rl1 || "",
        nombre_jefe_rl1: rl.nombre_jefe_rl1 || "",
        puesto_jefe_rl1: rl.puesto_jefe_rl1 || "",
        fecha_ingreso_rl1: rl.fecha_ingreso_rl1 || "",
        puesto_inicial_rl1: rl.puesto_inicial_rl1 || "",
        sueldo_inicial_rl1: rl.sueldo_inicial_rl1 || "",
        puesto_final_rl1: rl.puesto_final_rl1 || "",
        sueldo_final_rl1: rl.sueldo_final_rl1 || "",
        fecha_salida_rl1: rl.fecha_salida_rl1 || "",
        motivo_separacion_rl1: rl.motivo_separacion_rl1 || "",
        empresa_rl2: rl.empresa_rl2 || "",
        domicilio_rl2: rl.domicilio_rl2 || "",
        telefono_rl2: rl.telefono_rl2 || "",
        nombre_jefe_rl2: rl.nombre_jefe_rl2 || "",
        puesto_jefe_rl2: rl.puesto_jefe_rl2 || "",
        fecha_ingreso_rl2: rl.fecha_ingreso_rl2 || "",
        puesto_inicial_rl2: rl.puesto_inicial_rl2 || "",
        sueldo_inicial_rl2: rl.sueldo_inicial_rl2 || "",
        puesto_final_rl2: rl.puesto_final_rl2 || "",
        sueldo_final_rl2: rl.sueldo_final_rl2 || "",
        fecha_salida_rl2: rl.fecha_salida_rl2 || "",
        motivo_separacion_rl2: rl.motivo_separacion_rl2 || "",
        empresa_rl3: rl.empresa_rl3 || "",
        domicilio_rl3: rl.domicilio_rl3 || "",
        telefono_rl3: rl.telefono_rl3 || "",
        nombre_jefe_rl3: rl.nombre_jefe_rl3 || "",
        puesto_jefe_rl3: rl.puesto_jefe_rl3 || "",
        fecha_ingreso_rl3: rl.fecha_ingreso_rl3 || "",
        puesto_inicial_rl3: rl.puesto_inicial_rl3 || "",
        sueldo_inicial_rl3: rl.sueldo_inicial_rl3 || "",
        puesto_final_rl3: rl.puesto_final_rl3 || "",
        sueldo_final_rl3: rl.sueldo_final_rl3 || "",
        fecha_salida_rl3: rl.fecha_salida_rl3 || "",
        motivo_separacion_rl3: rl.motivo_separacion_rl3 || "",
      });
    }
  }, [queryLaborales.data, reset]);

  useEffect(() => {
    if (queryPersonales.data) {
      const rp = queryPersonales.data;
      reset({
        nombre_rp1: rp.nombre_rp1 || "",
        domicilio_rp1: rp.domicilio_rp1 || "",
        telefono_rp1: rp.telefono_rp1 || "",
        ocupacion_rp1: rp.ocupacion_rp1 || "",
        anios_conocerlo_rp1: rp.anios_conocerlo_rp1 || "",
        comentarios_rp1: rp.comentarios_rp1 || "",
        como_conoce_rp1: rp.como_conoce_rp1 || "",
        nombre_rp2: rp.nombre_rp2 || "",
        domicilio_rp2: rp.domicilio_rp2 || "",
        telefono_rp2: rp.telefono_rp2 || "",
        ocupacion_rp2: rp.ocupacion_rp2 || "",
        anios_conocerlo_rp2: rp.anios_conocerlo_rp2 || "",
        comentarios_rp2: rp.comentarios_rp2 || "",
        como_conoce_rp2: rp.como_conoce_rp2 || "",
      });
    }
  }, [queryPersonales.data, reset]);

  useEffect(() => {
    if (queryVecinales.data) {
      const rp = queryVecinales.data;
      reset({
        nombre_rv1: rp.nombre_rv1 || "",
        domicilio_rv1: rp.domicilio_rv1 || "",
        telefono_rv1: rp.telefono_rv1 || "",
        ocupacion_rv1: rp.ocupacion_rv1 || "",
        anios_conocerlo_rv1: rp.anios_conocerlo_rv1 || "",
        comentarios_rv1: rp.comentarios_rv1 || "",
        lo_recomienda_rv1: rp.lo_recomienda_rv1 || "",
        nombre_rv2: rp.nombre_rv2 || "",
        domicilio_rv2: rp.domicilio_rv2 || "",
        telefono_rv2: rp.telefono_rv2 || "",
        ocupacion_rv2: rp.ocupacion_rv2 || "",
        anios_conocerlo_rv2: rp.anios_conocerlo_rv2 || "",
        comentarios_rv2: rp.comentarios_rv2 || "",
        lo_recomienda_rv2: rp.lo_recomienda_rv2 || "",
      });
    }
  }, [queryVecinales.data, reset]);

  useEffect(() => {
    if (evaluadosList_id) {
      const token = localStorage.getItem("token");
      fetch(`${API}/evaluados/${evaluadosList_id}/photo/${nombreCompleto}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.url) {
            setPhotoUrl(data.url);
            console.log("URL de la foto:", data.url);
          } else {
            setPhotoUrl(null);
          }
        })
        .catch((error) => {
          console.error("Error al obtener la URL de la foto:", error);
          setPhotoUrl(null);
        });
    }
  }, [evaluadosList_id, nombreCompleto]);

  useEffect(() => {
    if (evaluadosList_id) {
      const token = localStorage.getItem("token");
      fetch(`${API}/evaluado/${evaluadosList_id}/ubicacion`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.photos) {
            setPhotoUrl2(data.photos[5] || null);
          } else {
            setPhotoUrl2(null);
          }
        })
        .catch((error) => {
          console.error("Error al obtener la URL de la foto:", error);
          setPhotoUrl2(null);
        });
    }
  }, [evaluadosList_id]);

  useEffect(() => {
    console.log("queryFecha.data:", queryFecha.data);

    if (queryFecha.data && queryFecha.data.length > 0) {
      const registroValido = queryFecha.data.find(
        (item) => item.fecha_bienesinmuebles
      );

      if (registroValido) {
        setValue("fecha_bienesinmuebles", registroValido.fecha_bienesinmuebles);
      }
    }
  }, [queryFecha.data, setValue]);

  useEffect(() => {
    if (querySemaforoVD.data) {
      const color = querySemaforoVD.data.color_se || "";

      let recommendation = "";
      if (color === "verde") {
        recommendation = "recomendable";
      } else if (color === "amarillo") {
        recommendation = "con_reserva";
      } else if (color === "rojo") {
        recommendation = "no_recomendable";
      }

      reset({
        color_se: color,
        evaluado_uuid: querySemaforoVD.data.evaluado_uuid || "",
      });

      setSelectedRecommendation(recommendation);

      if (recommendation === "recomendable") {
        setSelectedImage(Verde);
      } else if (recommendation === "con_reserva") {
        setSelectedImage(Amarillo);
      } else if (recommendation === "no_recomendable") {
        setSelectedImage(Rojo);
      }
    }
  }, [querySemaforoVD.data, reset]);

  if (queryEvaluado.isLoading) {
    return <Loading />;
  }

  const renderPage1 = () => (
    <div className={`space-y-4 p-4 ${isDarkMode ? "bg-gray-800 text-gray-200" : "bg-white text-gray-800"}`}>
      <div className="grid grid-cols-3 gap-4">
        {/* Fecha Visita */}
        <div className="col-span-1 flex items-center">
          <Label htmlFor="fecha_conclusionvd" className={`mr-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
            FECHA EVALUACIÓN:
          </Label>
          <TextInput
            id="fechaVisita"
            name="fechaVisita"
            type="date"
            value={
              queryFecha.data && queryFecha.data.length > 0
                ? queryFecha.data[0].fecha_conclusionvd || ""
                : ""
            }
            onChange={handleInputChange}
            className={`w-32 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-800 border-gray-300"}`}
          />
        </div>
        {/* Campo para nombre */}
        <div className="col-span-2">
          <Label htmlFor="nombre" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>NOMBRE:</Label>
          <TextInput
            id="nombre"
            name="nombre"
            value={`${queryEvaluado.data?.nombre || ""} ${
              queryEvaluado.data?.apellido_paterno || ""
            } ${queryEvaluado.data?.apellido_materno || ""}`}
            onChange={handleInputChange}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-400 border-gray-600" : "bg-gray-100 text-gray-500 border-gray-300"}`}
          />
        </div>

        {/* FOTO */}
        <div className={`w-64 h-64 border rounded-md overflow-hidden flex items-center justify-center mt-4 relative z-10 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300 bg-gray-100"}`}>
          {photoUrl ? (
            <img
              src={photoUrl}
              alt="Foto de evaluado"
              className="w-full h-full object-cover"
            />
          ) : (
            <span className={`${isDarkMode ? "text-gray-400" : "text-gray-500"}`}>Sin foto disponible</span>
          )}
        </div>
        {/* SEMAFORO */}
        <div className="flex items-center gap-4">
          {/* Radio buttons */}
          <div className="flex flex-col">
            <label className={`flex items-center gap-2 mt-4 mb-4 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              <input
                type="radio"
                name="recommendation"
                value="recomendable"
                checked={selectedRecommendation === "recomendable"}
                onChange={handleRadioChange}
                className={`${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-white border-gray-300"}`}
              />
              RECOMENDABLE
            </label>
            <label className={`flex items-center gap-2 mt-12 mb-12 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              <input
                type="radio"
                name="recommendation"
                value="con_reserva"
                checked={selectedRecommendation === "con_reserva"}
                onChange={handleRadioChange}
                className={`${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-white border-gray-300"}`}
              />
              CON RESERVA
            </label>
            <label className={`flex items-center gap-2 mb-12 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              <input
                type="radio"
                name="recommendation"
                value="no_recomendable"
                checked={selectedRecommendation === "no_recomendable"}
                onChange={handleRadioChange}
                className={`${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-white border-gray-300"}`}
              />
              NO RECOMENDABLE
            </label>
          </div>
          {/* Imagen de Semaforo */}
          <img src={selectedImage} alt="Semaforo" className="w-70 h-70" />
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4">
        {/* Campo para RFC */}
        <div className="col-span-1">
          <Label htmlFor="rfc" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>RFC:</Label>
          <TextInput
            id="rfc"
            name="rfc"
            onChange={handleInputChange}
            value={queryEvaluado.data?.rfc || ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-400 border-gray-600" : "bg-gray-100 text-gray-500 border-gray-300"}`}
          />
        </div>
        {/* Edad */}
        <div className="col-span-1">
          <Label htmlFor="edad" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>EDAD:</Label>
          <TextInput
            id="edad"
            name="edad"
            value={edad !== null ? edad.toString() : ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-400 border-gray-600" : "bg-gray-100 text-gray-500 border-gray-300"}`}
          />
        </div>
        {/* Género */}
        <div className="col-span-1">
          <Label htmlFor="sexo" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>SEXO:</Label>
          <TextInput
            id="sexo"
            name="sexo"
            onChange={handleInputChange}
            value={queryEvaluado.data?.genero || ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-400 border-gray-600" : "bg-gray-100 text-gray-500 border-gray-300"}`}
          />
        </div>
        {/* Estado Civil */}
        <div className="col-span-1">
          <Label htmlFor="estadoCivil" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>ESTADO CIVIL:</Label>
          <TextInput
            id="estadoCivil"
            name="estadoCivil"
            onChange={handleInputChange}
            value={queryEvaluado.data?.estado_civil || ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-400 border-gray-600" : "bg-gray-100 text-gray-500 border-gray-300"}`}
          />
        </div>
        {/* Escolaridad */}
        <div className="col-span-1">
          <Label htmlFor="escolaridad" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>ESCOLARIDAD:</Label>
          <TextInput
            id="escolaridad"
            name="escolaridad"
            onChange={handleInputChange}
            value={queryEvaluado.data?.escolaridad || ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-400 border-gray-600" : "bg-gray-100 text-gray-500 border-gray-300"}`}
          />
        </div>
        {/* Fecha de Nacimiento */}
        <div className="col-span-1 flex items-center">
          <Label htmlFor="fechaNacimiento" className={`mr-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
            FECHA DE NACIMIENTO:
          </Label>
          <TextInput
            id="fechaNacimiento"
            name="fechaNacimiento"
            value={queryEvaluado.data?.fecha_nacimiento || ""}
            disabled={true}
            type="date"
            className={`w-32 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-800 border-gray-300"}`}
          />
        </div>
        {/* CURP */}
        <div className="col-span-1">
          <Label htmlFor="curp" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>CURP:</Label>
          <TextInput
            id="curp"
            name="curp"
            onChange={handleInputChange}
            value={queryEvaluado.data?.curp || ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-400 border-gray-600" : "bg-gray-100 text-gray-500 border-gray-300"}`}
          />
        </div>
        {/* Empresa */}
        <div className="col-span-1">
          <Label htmlFor="empresa" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>EMPRESA:</Label>
          <TextInput
            id="empresa_id"
            name="empresa"
            value={queryEvaluado.data?.empresa_id?.nombre || ""}
            onChange={handleInputChange}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-400 border-gray-600" : "bg-gray-100 text-gray-500 border-gray-300"}`}
          />
        </div>
      </div>
    </div>
  );

  const renderPage2 = () => (
    <div className={`space-y-6 p-6 rounded-lg shadow-md ${isDarkMode ? "bg-gray-800" : "bg-gray-50"}`}>
      <div className={`p-4 rounded-lg shadow ${isDarkMode ? "bg-blue-800 text-white" : "bg-customBlue text-white"}`}>
        <h2 className="font-bold text-xl">
          CONCLUSIONES DE EVALUACIÓN DE VISITA DOMICILIARIA
        </h2>
      </div>

      <div className={`flex flex-col items-center border-dashed border-4 rounded-lg p-8 space-y-4 relative ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>CONCLUSIÓN</p>
        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
          Derivado de la valoración y revisión de la información, se considera
          que es una persona{" "}
          <Controller
            name="resultado2"
            control={control}
            defaultValue={
              queryConclusionVD.data && queryConclusionVD.data.length > 0
                ? queryConclusionVD.data[0].resultado2 || ""
                : ""
            }
            render={({ field }) => (
              <input
                {...field}
                id="resultado2"
                type="text"
                name="resultado2"
                className={`border rounded-md p-2 w-[400px] inline-block mt-2 mb-2 focus:ring-2 focus:ring-blue-400 ${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600 placeholder-gray-400" : "bg-white text-gray-800 border-gray-300 placeholder-gray-500"}`}
              />
            )}
          />{" "}
          en virtud de que al momento de la evaluación de visita domiciliaria se
          detectó que
          <p>
            <Controller
              name="detecto_vd"
              control={control}
              defaultValue={
                queryConclusionVD.data && queryConclusionVD.data.length > 0
                  ? queryConclusionVD.data[0].detecto_vd || ""
                  : ""
              }
              render={({ field }) => (
                <textarea
                  {...field}
                  onInput={(e) => {
                    const target = e.target as HTMLTextAreaElement;
                    target.style.height = "auto";
                    target.style.height = `${target.scrollHeight}px`;
                  }}
                  id="detecto_vd"
                  className={`w-[785px] border rounded-lg p-2 focus:outline-none focus:border-blue-500 ${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600 placeholder-gray-400" : "bg-white text-gray-800 border-gray-300 placeholder-gray-500"}`}
                  placeholder="Escribe aqui..."
                />
              )}
            />
          </p>
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>DATOS GENERALES</p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryEvaluado.data?.nombre || ""} ${
              queryEvaluado.data?.apellido_paterno || ""
            } ${queryEvaluado.data?.apellido_materno || ""}`}
          </label>{" "}
          Durante esta etapa de la examinación, se le interrogó sobre sus datos
          generales, el candidato dijo ser el{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`C. ${queryEvaluado.data?.nombre || ""} ${
              queryEvaluado.data?.apellido_paterno || ""
            } ${queryEvaluado.data?.apellido_materno || ""}`}
          </label>{" "}
          ; indicó contar con{" "}
          <label
            htmlFor="edad"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {edad !== null ? edad.toString() : ""}
          </label>{" "}
          años cumplidos a la fecha de la evaluación.
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
          Manifestó que nació el{" "}
          <label
            id="fechaNacimiento"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {queryEvaluado.data?.fecha_nacimiento
              ? (function () {
                  const date = new Date(queryEvaluado.data?.fecha_nacimiento);
                  const day = String(date.getUTCDate()).padStart(2, "0");
                  const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Mes comienza en 0
                  const year = date.getUTCFullYear();
                  return `${day}-${month}-${year}`;
                })()
              : ""}
          </label>{" "}
          en{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryEvaluado.data?.lugar_nacimiento || ""}`}
          </label>
          , por lo que aseguró ser de Nacionalidad Mexicana, negó contar con una
          doble nacionalidad.
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
          Manifestó que labora para la empresa{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryEvaluado.data?.empresa_id?.nombre || ""}`}
          </label>{" "}
          que tiene el puesto de{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryEvaluado.data?.puesto || ""}`}
          </label>
          .
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
          Afirmó que cuenta con número fijo y el celular:{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryEvaluado.data?.telefono || ""}`}
          </label>
          .
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
          Se procedió a la revisión, valoración, e identificación de riesgos de
          toda la información que se recabo en la visita domiciliaria detectando
          lo siguiente:
        </p>
      </div>

      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          BIENES INMUEBLES/MUEBLES
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
          Se identifico que posee un automóvil marca{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {queryAuto.data && queryAuto.data.length > 0
              ? queryAuto.data[0].marca_autobienes1 || ""
              : ""}
          </label>
          , modelo{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {queryAuto.data && queryAuto.data.length > 0
              ? queryAuto.data[0].modelo_autobienes1 || ""
              : ""}
          </label>
          , precio estimado de{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`$${
              queryAuto.data && queryAuto.data.length > 0
                ? queryAuto.data[0].precio_autobienes1 || ""
                : ""
            }`}
          </label>
        </p>
      </div>

      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>BIENES RAICES</p>
        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
          Cuenta con un/una{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {queryBienesRaices.data && queryBienesRaices.data.length > 0
              ? queryBienesRaices.data[0].tipo_bienes1 || ""
              : ""}
          </label>{" "}
          a nombre de{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {queryBienesRaices.data && queryBienesRaices.data.length > 0
              ? queryBienesRaices.data[0].liquidado_nombre_bienes1 || ""
              : ""}
          </label>
          , ubicado en{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {queryBienesRaices.data && queryBienesRaices.data.length > 0
              ? queryBienesRaices.data[0].ubicacion_bienes1 || ""
              : ""}
          </label>{" "}
          de precio estimado{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`$${
              queryBienesRaices.data && queryBienesRaices.data.length > 0
                ? queryBienesRaices.data[0].precio_bienes1 || ""
                : ""
            }`}
          </label>
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          SITUACION DEL INMUEBLE
        </p>
        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
          El inmueble que habita el evaluado es{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {querySituacionInmueble.data &&
            querySituacionInmueble.data.length > 0
              ? querySituacionInmueble.data[0].situacion_del_inmueble || ""
              : ""}
          </label>{" "}
          , se encuentra en una zona de nivel socioeconómico{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {queryZonaInmueble.data && queryZonaInmueble.data.length > 0
              ? queryZonaInmueble.data[0].zona_del_inmueble || ""
              : ""}
          </label>
          , ubicado en{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {queryBienesRaices.data && queryBienesRaices.data.length > 0
              ? queryBienesRaices.data[0].ubicacion_bienes1 || ""
              : ""}
          </label>{" "}
          de precio estimado{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`$${
              queryBienesRaices.data && queryBienesRaices.data.length > 0
                ? queryBienesRaices.data[0].precio_bienes1 || ""
                : ""
            }`}
          </label>
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
          <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              NOTAS DE LA ZONA y RIESGOS PARA LA EMPRESA
          </p>
          <Controller
              name="nota_bienes2"
              control={control}
              defaultValue={
                  queryNotasBienes.data && queryNotasBienes.data.length > 0
                      ? queryNotasBienes.data[0].nota_bienes2 || ""
                      : ""
              }
              render={({ field }) => (
                  <div>
                      <textarea
                          id="nota_bienes2"
                          {...field}
                          onInput={(e) => {
                              const target = e.target as HTMLTextAreaElement;
                              target.style.height = "auto";
                              target.style.height = `${target.scrollHeight}px`;
                          }}
                          style={{ height: "auto", overflow: "hidden" }}
                          disabled={true}
                          className={`w-[785px] border rounded-lg p-2 focus:outline-none focus:border-blue-500 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-800 border-gray-300"}`}
                          placeholder="Escribe aquí tus notas..."
                      />
                  </div>
              )}
          />
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          INTERIOR DEL INMUEBLE
        </p>
        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
          El inmueble se encuentra en las siguientes condiciones: ORDEN{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`(${
              queryInteriorInmueble.data &&
              queryInteriorInmueble.data.length > 0
                ? queryInteriorInmueble.data[0].orden || ""
                : ""
            })`}
          </label>
          , LIMPIEZA{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`(${
              queryInteriorInmueble.data &&
              queryInteriorInmueble.data.length > 0
                ? queryInteriorInmueble.data[0].limpieza || ""
                : ""
            })`}
          </label>
          , MOBILIARIO{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`(${
              queryInteriorInmueble.data &&
              queryInteriorInmueble.data.length > 0
                ? queryInteriorInmueble.data[0].mobiliario || ""
                : ""
            })`}
          </label>{" "}
          , DISTRIBUCIÓN{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`(${
              queryInteriorInmueble.data &&
              queryInteriorInmueble.data.length > 0
                ? queryInteriorInmueble.data[0].distribucion || ""
                : ""
            })`}
          </label>
          .
          <Controller
            name="nota_inmueblecasa"
            control={control}
            defaultValue={
              queryNotasInmueble.data && queryNotasInmueble.data.length > 0
                ? queryNotasInmueble.data[0].nota_inmueblecasa || ""
                : ""
            }
            render={({ field }) => (
              <div>
                <textarea
                  id="nota_inmueblecasa"
                  {...field}
                  onInput={(e) => {
                    const target = e.target as HTMLTextAreaElement;
                    target.style.height = "auto";
                    target.style.height = `${target.scrollHeight}px`;
                  }}
                  style={{ height: "auto", overflow: "hidden" }}
                  disabled={true}
                  className={`w-[785px] border rounded-lg p-2 focus:outline-none focus:border-blue-500 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 placeholder-gray-400" : "bg-white text-gray-800 border-gray-300 placeholder-gray-500"}`}
                  placeholder="Escribe aquí tus notas..."
                />
              </div>
            )}
          />
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            ZONAS DEL INTERIOR DEL INMUEBLE
        </p>
        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
            El interior del inmueble del evaluado cuenta con:{" "}
        </p>
        <div className="pl-[200px]">
            <div className="grid grid-cols-2 gap-6 p-4">
                <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                    <Controller
                        name="sala_comedor"
                        control={control}
                        render={({ field: { onChange, value, ...field } }) => (
                            <Checkbox
                                id="sala_comedor"
                                checked={zonasSeleccionadas.sala}
                                disabled={true}
                                onChange={() => {
                                    const newValue = !(zonasSeleccionadas.sala ?? false);
                                    setZonasSeleccionadas((prev) => ({
                                        ...prev,
                                        sala: newValue,
                                    }));
                                    onChange(newValue);
                                }}
                                className={`${isDarkMode ? "bg-gray-700 border-gray-600 text-blue-400" : "bg-white border-gray-300 text-blue-600"}`}
                            />
                        )}
                    />
                    <span>Sala comedor</span>
                </label>

                <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                    <Controller
                        name="cocina"
                        control={control}
                        render={({ field: { onChange, value, ...field } }) => (
                            <Checkbox
                                id="cocina"
                                checked={zonasSeleccionadas.cocina}
                                disabled={true}
                                onChange={() => {
                                    const newValue = !(zonasSeleccionadas.cocina ?? false);
                                    setZonasSeleccionadas((prev) => ({
                                        ...prev,
                                        cocina: newValue,
                                    }));
                                    onChange(newValue);
                                }}
                                className={`${isDarkMode ? "bg-gray-700 border-gray-600 text-blue-400" : "bg-white border-gray-300 text-blue-600"}`}
                            />
                        )}
                    />
                    <span>Cocina</span>
                </label>

                <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                    <Controller
                        name="recamaras"
                        control={control}
                        render={({ field: { onChange, value, ...field } }) => (
                            <Checkbox
                                id="recamaras"
                                checked={zonasSeleccionadas.recamaras}
                                disabled={true}
                                onChange={() => {
                                    const newValue = !(zonasSeleccionadas.recamaras ?? false);
                                    setZonasSeleccionadas((prev) => ({
                                        ...prev,
                                        recamaras: newValue,
                                    }));
                                    onChange(newValue);
                                }}
                                {...field}
                                className={`${isDarkMode ? "bg-gray-700 border-gray-600 text-blue-400" : "bg-white border-gray-300 text-blue-600"}`}
                            />
                        )}
                    />
                    <span>Recámaras</span>
                </label>

                <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                    <Controller
                        name="cochera"
                        control={control}
                        render={({ field: { onChange, value, ...field } }) => (
                            <Checkbox
                                id="cochera"
                                checked={zonasSeleccionadas.cochera}
                                disabled={true}
                                onChange={() => {
                                    const newValue = !(zonasSeleccionadas.cochera ?? false);
                                    setZonasSeleccionadas((prev) => ({
                                        ...prev,
                                        cochera: newValue,
                                    }));
                                    onChange(newValue);
                                }}
                                {...field}
                                className={`${isDarkMode ? "bg-gray-700 border-gray-600 text-blue-400" : "bg-white border-gray-300 text-blue-600"}`}
                            />
                        )}
                    />
                    <span>Cochera</span>
                </label>

                <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                    <Controller
                        name="area_lavado"
                        control={control}
                        render={({ field: { onChange, value, ...field } }) => (
                            <Checkbox
                                id="area_lavado"
                                checked={zonasSeleccionadas.lavado}
                                disabled={true}
                                onChange={() => {
                                    const newValue = !(zonasSeleccionadas.lavado ?? false);
                                    setZonasSeleccionadas((prev) => ({
                                        ...prev,
                                        lavado: newValue,
                                    }));
                                    onChange(newValue);
                                }}
                                {...field}
                                className={`${isDarkMode ? "bg-gray-700 border-gray-600 text-blue-400" : "bg-white border-gray-300 text-blue-600"}`}
                            />
                        )}
                    />
                    <span>Área de lavado</span>
                </label>

                <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                    <Controller
                        name="banios_completos"
                        control={control}
                        render={({ field: { onChange, value, ...field } }) => (
                            <Checkbox
                                id="banios_completos"
                                checked={zonasSeleccionadas.baniosCompletos}
                                disabled={true}
                                onChange={() => {
                                    const newValue = !(
                                        zonasSeleccionadas.baniosCompletos ?? false
                                    );
                                    setZonasSeleccionadas((prev) => ({
                                        ...prev,
                                        baniosCompletos: newValue,
                                    }));
                                    onChange(newValue);
                                }}
                                {...field}
                                className={`${isDarkMode ? "bg-gray-700 border-gray-600 text-blue-400" : "bg-white border-gray-300 text-blue-600"}`}
                            />
                        )}
                    />
                    <span>Baños completos</span>
                </label>

                <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                    <Controller
                        name="medios_banios"
                        control={control}
                        render={({ field: { onChange, value, ...field } }) => (
                            <Checkbox
                                id="medios_banios"
                                checked={zonasSeleccionadas.mediosBanios}
                                disabled={true}
                                onChange={() => {
                                    const newValue = !(
                                        zonasSeleccionadas.mediosBanios ?? false
                                    );
                                    setZonasSeleccionadas((prev) => ({
                                        ...prev,
                                        mediosBanios: newValue,
                                    }));
                                    onChange(newValue);
                                }}
                                {...field}
                                className={`${isDarkMode ? "bg-gray-700 border-gray-600 text-blue-400" : "bg-white border-gray-300 text-blue-600"}`}
                            />
                        )}
                    />
                    <span>Medios baños</span>
                </label>

                <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                    <Controller
                        name="jaula_tendido"
                        control={control}
                        render={({ field: { onChange, value, ...field } }) => (
                            <Checkbox
                                id="jaula_tendido"
                                checked={zonasSeleccionadas.jaula}
                                disabled={true}
                                onChange={() => {
                                    const newValue = !(zonasSeleccionadas.jaula ?? false);
                                    setZonasSeleccionadas((prev) => ({
                                        ...prev,
                                        jaula: newValue,
                                    }));
                                    onChange(newValue);
                                }}
                                {...field}
                                className={`${isDarkMode ? "bg-gray-700 border-gray-600 text-blue-400" : "bg-white border-gray-300 text-blue-600"}`}
                            />
                        )}
                    />
                    <span>Jaula de tendido</span>
                </label>

                <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                    <Controller
                        name="balcones"
                        control={control}
                        render={({ field: { onChange, value, ...field } }) => (
                            <Checkbox
                                id="balcones"
                                checked={zonasSeleccionadas.balcones}
                                disabled={true}
                                onChange={() => {
                                    const newValue = !(zonasSeleccionadas.balcones ?? false);
                                    setZonasSeleccionadas((prev) => ({
                                        ...prev,
                                        balcones: newValue,
                                    }));
                                    onChange(newValue);
                                }}
                                {...field}
                                className={`${isDarkMode ? "bg-gray-700 border-gray-600 text-blue-400" : "bg-white border-gray-300 text-blue-600"}`}
                            />
                        )}
                    />
                    <span>Balcones</span>
                </label>

                <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                    <Controller
                        name="patios"
                        control={control}
                        render={({ field: { onChange, value, ...field } }) => (
                            <Checkbox
                                id="patios"
                                checked={zonasSeleccionadas.patios}
                                disabled={true}
                                onChange={() => {
                                    const newValue = !(zonasSeleccionadas.patios ?? false);
                                    setZonasSeleccionadas((prev) => ({
                                        ...prev,
                                        patios: newValue,
                                    }));
                                    onChange(newValue);
                                }}
                                {...field}
                                className={`${isDarkMode ? "bg-gray-700 border-gray-600 text-blue-400" : "bg-white border-gray-300 text-blue-600"}`}
                            />
                        )}
                    />
                    <span>Patios</span>
                </label>
            </div>
        </div>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
          <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>ESPACIOS</p>
          <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              El inmueble que habita el evaluado cuenta con espacio{" "}
              <label
                  htmlFor="nombre"
                  className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
              >
                  {`(${
                      queryEspacioInmueble.data && queryEspacioInmueble.data.length > 0
                          ? queryEspacioInmueble.data[0].espacio_del_inmueblecasa || ""
                          : ""
                  })`}
              </label>
          </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>SERVICIOS</p>
        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
          El inmueble cuenta con los siguientes servicios:{" "}
          <div className="pl-[175px]">
            <div className="grid grid-cols-3 gap-4 p-4">
              <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                <Controller
                  name="agua"
                  control={control}
                  render={({ field: { onChange, value, ...field } }) => (
                    <Checkbox
                      id="agua"
                      checked={serviciosSeleccionados.agua ?? false}
                      disabled={true}
                      onChange={() => {
                        const newValue = !(
                          serviciosSeleccionados.agua ?? false
                        );
                        setServiciosSeleccionados((prev) => ({
                          ...prev,
                          agua: newValue,
                        }));
                        onChange(newValue);
                      }}
                      {...field}
                      className={`${isDarkMode ? "bg-gray-700 border-gray-600 text-blue-400" : "bg-white border-gray-300 text-blue-600"}`}
                    />
                  )}
                />
                <span>Agua</span>
              </label>
              <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                <Controller
                  name="drenaje"
                  control={control}
                  render={({ field: { onChange, value, ...field } }) => (
                    <Checkbox
                      id="drenaje"
                      checked={serviciosSeleccionados.drenaje ?? false}
                      disabled={true}
                      onChange={() => {
                        const newValue = !(
                          serviciosSeleccionados.drenaje ?? false
                        );
                        setServiciosSeleccionados((prev) => ({
                          ...prev,
                          drenaje: newValue,
                        }));
                        onChange(newValue);
                      }}
                      {...field}
                      className={`${isDarkMode ? "bg-gray-700 border-gray-600 text-blue-400" : "bg-white border-gray-300 text-blue-600"}`}
                    />
                  )}
                />
                <span>Drenaje</span>
              </label>
              <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                <Controller
                  name="transporte"
                  control={control}
                  render={({ field: { onChange, value, ...field } }) => (
                    <Checkbox
                      id="transporte"
                      checked={serviciosSeleccionados.transporte ?? false}
                      disabled={true}
                      onChange={() => {
                        const newValue = !(
                          serviciosSeleccionados.transporte ?? false
                        );
                        setServiciosSeleccionados((prev) => ({
                          ...prev,
                          transporte: newValue,
                        }));
                        onChange(newValue);
                      }}
                      {...field}
                      className={`${isDarkMode ? "bg-gray-700 border-gray-600 text-blue-400" : "bg-white border-gray-300 text-blue-600"}`}
                    />
                  )}
                />
                <span>Transporte</span>
              </label>
              <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                <Controller
                  name="vigilancia"
                  control={control}
                  render={({ field: { onChange, value, ...field } }) => (
                    <Checkbox
                      id="vigilancia"
                      checked={serviciosSeleccionados.vigilancia ?? false}
                      disabled={true}
                      onChange={() => {
                        const newValue = !(
                          serviciosSeleccionados.vigilancia ?? false
                        );
                        setServiciosSeleccionados((prev) => ({
                          ...prev,
                          vigilancia: newValue,
                        }));
                        onChange(newValue);
                      }}
                      {...field}
                      className={`${isDarkMode ? "bg-gray-700 border-gray-600 text-blue-400" : "bg-white border-gray-300 text-blue-600"}`}
                    />
                  )}
                />
                <span>Vigilancia</span>
              </label>
              <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                <Controller
                  name="telefono"
                  control={control}
                  render={({ field: { onChange, value, ...field } }) => (
                    <Checkbox
                      id="telefono"
                      checked={serviciosSeleccionados.telefono ?? false}
                      disabled={true}
                      onChange={() => {
                        const newValue = !(
                          serviciosSeleccionados.telefono ?? false
                        );
                        setServiciosSeleccionados((prev) => ({
                          ...prev,
                          telefono: newValue,
                        }));
                        onChange(newValue);
                      }}
                      {...field}
                      className={`${isDarkMode ? "bg-gray-700 border-gray-600 text-blue-400" : "bg-white border-gray-300 text-blue-600"}`}
                    />
                  )}
                />
                <span>Teléfono</span>
              </label>
              <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                <Controller
                  name="luz"
                  control={control}
                  render={({ field: { onChange, value, ...field } }) => (
                    <Checkbox
                      id="luz"
                      checked={serviciosSeleccionados.luz ?? false}
                      disabled={true}
                      onChange={() => {
                        const newValue = !(serviciosSeleccionados.luz ?? false);
                        setServiciosSeleccionados((prev) => ({
                          ...prev,
                          luz: newValue,
                        }));
                        onChange(newValue);
                      }}
                      {...field}
                      className={`${isDarkMode ? "bg-gray-700 border-gray-600 text-blue-400" : "bg-white border-gray-300 text-blue-600"}`}
                    />
                  )}
                />
                <span>Luz</span>
              </label>
              <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                <Controller
                  name="pavimentacion"
                  control={control}
                  render={({ field: { onChange, value, ...field } }) => (
                    <Checkbox
                      id="pavimentacion"
                      checked={serviciosSeleccionados.pavimentacion ?? false}
                      disabled={true}
                      onChange={() => {
                        const newValue = !(
                          serviciosSeleccionados.pavimentacion ?? false
                        );
                        setServiciosSeleccionados((prev) => ({
                          ...prev,
                          pavimentacion: newValue,
                        }));
                        onChange(newValue);
                      }}
                      {...field}
                      className={`${isDarkMode ? "bg-gray-700 border-gray-600 text-blue-400" : "bg-white border-gray-300 text-blue-600"}`}
                    />
                  )}
                />
                <span>Pavimentación</span>
              </label>
            </div>
          </div>
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
          <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              UBICACIÓN Y SERVICIOS DE LA ZONA
          </p>
          <div className="pl-[225px]">
              {images.map((image, index) => (
                  <div
                      key={index}
                      className={`flex items-center justify-center border-dashed border-4 rounded-lg p-8 ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-100 border-gray-300"}`}
                  >
                      <div className="text-center">
                          <input
                              type="file"
                              accept="image/*"
                              className="hidden mb-4"
                              id={`imageUpload-${index}`}
                              onChange={(event) => handleImageChange(index, event)}
                          />
                          {image ? (
                              <img
                                  alt={`Uploaded ${index + 1}`}
                                  className="rounded object-cover max-w-full h-auto"
                              />
                          ) : photoUrl2 ? (
                              <img
                                  src={photoUrl2}
                                  alt="Foto de evaluado"
                                  className="rounded object-cover max-w-full h-auto"
                              />
                          ) : (
                              <span className={`text-gray-500 ${isDarkMode ? "text-gray-400" : "text-gray-500"}`}>Sin foto disponible</span>
                          )}
                      </div>
                  </div>
              ))}
          </div>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
          <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              INFORMACIÓN FAMILIAR
          </p>
          <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              En la entrevista refirió que se entrevistó a{" "}
              <label
                  htmlFor="entrevisto_vd"
                  className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
              >
                  <Controller
                      name="entrevisto_vd"
                      control={control}
                      defaultValue={
                          queryConclusionVD.data && queryConclusionVD.data.length > 0
                              ? queryConclusionVD.data[0].entrevisto_vd || ""
                              : ""
                      }
                      render={({ field }) => (
                          <select
                              id="nombre"
                              {...field}
                              disabled={true}
                              className={`font-medium block border rounded px-5 py-2 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-800 border-gray-300"}`}
                          >
                              {queryPadresHermanos.data &&
                              queryPadresHermanos.data.length > 0 ? (
                                  <>
                                      {queryPadresHermanos.data[0].nombre_ph1 && (
                                          <option value={queryPadresHermanos.data[0].nombre_ph1}>
                                              {queryPadresHermanos.data[0].nombre_ph1}
                                          </option>
                                      )}
                                      {queryPadresHermanos.data[0].nombre_ph2 && (
                                          <option value={queryPadresHermanos.data[0].nombre_ph2}>
                                              {queryPadresHermanos.data[0].nombre_ph2}
                                          </option>
                                      )}
                                      {queryPadresHermanos.data[0].nombre_ph3 && (
                                          <option value={queryPadresHermanos.data[0].nombre_ph3}>
                                              {queryPadresHermanos.data[0].nombre_ph3}
                                          </option>
                                      )}
                                      {queryPadresHermanos.data[0].nombre_ph4 && (
                                          <option value={queryPadresHermanos.data[0].nombre_ph4}>
                                              {queryPadresHermanos.data[0].nombre_ph4}
                                          </option>
                                      )}
                                      {queryPadresHermanos.data[0].nombre_ph5 && (
                                          <option value={queryPadresHermanos.data[0].nombre_ph5}>
                                              {queryPadresHermanos.data[0].nombre_ph5}
                                          </option>
                                      )}
                                  </>
                              ) : (
                                  <option value="">No hay nombres disponibles</option>
                              )}
                              {queryConyuge.data &&
                              queryConyuge.data.length > 0 &&
                              queryConyuge.data[0].nombrec && (
                                  <option value={queryConyuge.data[0].nombrec}>
                                      {queryConyuge.data[0].nombrec}
                                  </option>
                              )}
                              {queryHijos.data?.nombreh1 && (
                                  <option value={queryHijos.data?.nombreh1}>
                                      {queryHijos.data?.nombreh1}
                                  </option>
                              )}
                              {queryHijos.data?.nombreh2 && (
                                  <option value={queryHijos.data?.nombreh2}>
                                      {queryHijos.data?.nombreh2}
                                  </option>
                              )}
                              {queryHijos.data?.nombreh3 && (
                                  <option value={queryHijos.data?.nombreh3}>
                                      {queryHijos.data?.nombreh3}
                                  </option>
                              )}
                              {queryHijos.data?.nombreh4 && (
                                  <option value={queryHijos.data?.nombreh4}>
                                      {queryHijos.data?.nombreh4}
                                  </option>
                              )}
                          </select>
                      )}
                  />
              </label>
          </p>
          <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              El evaluado manifestó que su coyuge se llama{" "}
              <label
                  htmlFor="nombre"
                  className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
              >
                  {queryConyuge.data && queryConyuge.data.length > 0
                      ? queryConyuge.data[0].nombrec || ""
                      : ""}
              </label>{" "}
              cuenta con{" "}
              <label
                  htmlFor="nombre"
                  className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
              >
                  {queryConyuge.data && queryConyuge.data.length > 0
                      ? queryConyuge.data[0].edadc || ""
                      : ""}
              </label>{" "}
              años, vive en el domicilio ubicado en{" "}
              <label
                  htmlFor="nombre"
                  className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
              >
                  {queryConyuge.data && queryConyuge.data.length > 0
                      ? queryConyuge.data[0].domicilioc || ""
                      : ""}
              </label>{" "}
              , su actividad laboral es{" "}
              <label
                  htmlFor="nombre"
                  className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
              >
                  {queryConyuge.data && queryConyuge.data.length > 0
                      ? queryConyuge.data[0].actividad_laboralc || ""
                      : ""}
              </label>
              , cuenta con el ultimo grado de estudios de{" "}
              <label
                  htmlFor="nombre"
                  className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
              >
                  {queryConyuge.data && queryConyuge.data.length > 0
                      ? queryConyuge.data[0].ultimogrado_estudiosc || ""
                      : ""}
              </label>{" "}
          </p>
          <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              El evaluado refiere que tiene{" "}
              <label
                  htmlFor="nombre"
                  className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
              >
                  {(() => {
                      const hijos = [
                          queryHijos.data?.nombreh1,
                          queryHijos.data?.nombreh2,
                          queryHijos.data?.nombreh3,
                          queryHijos.data?.nombreh4,
                      ].filter(Boolean);

                      return hijos.length > 0
                          ? `${hijos.length} hijos de nombre (${hijos.join(", ")})`
                          : "No hay hijos registrados";
                  })()}
              </label>
              , edad{" "}
              <label
                  htmlFor="nombre"
                  className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
              >
                  {(() => {
                      const hijos = [
                          queryHijos.data?.edadh1,
                          queryHijos.data?.edadh2,
                          queryHijos.data?.edadh3,
                          queryHijos.data?.edadh4,
                      ]
                          .filter(Boolean)
                          .map((edad) => `${edad} ${edad === 1 ? "año" : "años"}`);

                      return hijos.length > 0
                          ? `(${hijos.join(", ")})`
                          : "No hay edades registradas";
                  })()}
              </label>
              respectivamente.
          </p>
          <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>NOTAS</p>
              <div className="space-y-4">
                  <Controller
                      name="nota_f"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                          <textarea
                              id="nota_f"
                              name="nota_f"
                              value={
                                  field.value ||
                                  (queryNotasInfoFam.data && queryNotasInfoFam.data.length > 0
                                      ? queryNotasInfoFam.data[0]?.nota_f || ""
                                      : "")
                              }
                              disabled={true}
                              rows={6}
                              onInput={(e) => {
                                  const target = e.target as HTMLTextAreaElement;
                                  target.style.height = "auto";
                                  target.style.height = `${target.scrollHeight}px`;
                              }}
                              className={`w-[785px] border rounded-lg p-2 focus:outline-none focus:border-blue-500 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 placeholder-gray-400" : "bg-white text-gray-800 border-gray-300 placeholder-gray-500"}`}
                              style={{ height: "auto", overflow: "hidden" }}
                          />
                      )}
                  />
              </div>
          </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
          <p className={`text-2xl font-semibold mb-6 ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
              REFERENCIAS LABORALES
          </p>
          <p className={`text-lg mb-6 ${isDarkMode ? "text-gray-400" : "text-gray-700"}`}>
              El evaluado manifestó que cuenta con las siguientes referencias
              laborales:
          </p>

          {/* Tabla de referencias laborales 1 */}
          <div className={`overflow-x-auto w-full border rounded-lg shadow-md ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
              <table className="min-w-full table-fixed text-left text-sm">
                  <thead className={`${isDarkMode ? "bg-gray-600 text-gray-200" : "bg-gray-200 text-gray-800"}`}>
                      <tr>
                          <th className="w-1/2 px-4 py-2 font-medium">Campo</th>
                          <th className="w-1/2 px-4 py-2 font-medium">Información</th>
                      </tr>
                  </thead>
                  <tbody className={`${isDarkMode ? "text-gray-300" : "text-gray-600"}`}>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">EMPRESA</td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.empresa_rl1}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">DOMICILIO</td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.domicilio_rl1}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">TELÉFONO</td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.telefono_rl1}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">
                              NOMBRE DEL JEFE INMEDIATO
                          </td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.nombre_jefe_rl1}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">
                              PUESTO DEL JEFE INMEDIATO
                          </td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.puesto_jefe_rl1}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">FECHA DE INGRESO</td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.fecha_ingreso_rl1
                                  ? queryLaborales.data.fecha_ingreso_rl1
                                        .split("-")
                                        .reverse()
                                        .join("/")
                                  : "No disponible"}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">PUESTO INICIAL</td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.puesto_inicial_rl1}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">SUELDO INICIAL</td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.sueldo_inicial_rl1
                                  ? `$${queryLaborales.data.sueldo_inicial_rl1}`
                                  : ""}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">PUESTO FINAL</td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.puesto_final_rl1}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">SUELDO FINAL</td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.sueldo_final_rl1
                                  ? `$${queryLaborales.data?.sueldo_final_rl1}`
                                  : ""}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">FECHA DE SALIDA</td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.fecha_salida_rl1
                                  ? queryLaborales.data.fecha_salida_rl1
                                        .split("-")
                                        .reverse()
                                        .join("/")
                                  : ""}
                          </td>
                      </tr>
                  </tbody>
              </table>
              <p className={`mt-2 px-4 py-2 font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                  MOTIVO DE LA SEPARACIÓN
              </p>
              <Controller
                  name="motivo_separacion_rl1"
                  control={control}
                  defaultValue={queryLaborales.data?.motivo_separacion_rl1 || ""}
                  render={({ field }) => (
                      <textarea
                          id="motivo_separacion_rl1"
                          {...field}
                          disabled={true}
                          rows={6}
                          className={`m-2 w-[750px] text-base p-3 border rounded-md ${isDarkMode ? "bg-gray-800 text-gray-200 border-gray-600 placeholder-gray-400" : "bg-white text-gray-800 border-gray-300"}`}
                      />
                  )}
              />
          </div>
          <br />

          {/* Tabla de referencias laborales 2 */}
          <div className={`overflow-x-auto w-full border rounded-lg shadow-md ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
              <table className="min-w-full table-fixed text-left text-sm">
                  <thead className={`${isDarkMode ? "bg-gray-600 text-gray-200" : "bg-gray-200 text-gray-800"}`}>
                      <tr>
                          <th className="w-1/2 px-4 py-2 font-medium">Campo</th>
                          <th className="w-1/2 px-4 py-2 font-medium">Información</th>
                      </tr>
                  </thead>
                  <tbody className={`${isDarkMode ? "text-gray-300" : "text-gray-600"}`}>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">EMPRESA</td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.empresa_rl2}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">DOMICILIO</td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.domicilio_rl2}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">TELÉFONO</td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.telefono_rl2}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">
                              NOMBRE DEL JEFE INMEDIATO
                          </td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.nombre_jefe_rl2}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">
                              PUESTO DEL JEFE INMEDIATO
                          </td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.puesto_jefe_rl2}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">FECHA DE INGRESO</td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.fecha_ingreso_rl2
                                  ? queryLaborales.data.fecha_ingreso_rl2
                                        .split("-")
                                        .reverse()
                                        .join("/")
                                  : "No disponible"}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">PUESTO INICIAL</td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.puesto_inicial_rl2}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">SUELDO INICIAL</td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.sueldo_inicial_rl2
                                  ? `$${queryLaborales.data.sueldo_inicial_rl2}`
                                  : ""}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">PUESTO FINAL</td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.puesto_final_rl2}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">SUELDO FINAL</td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.sueldo_final_rl2
                                  ? `$${queryLaborales.data?.sueldo_final_rl2}`
                                  : ""}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">FECHA DE SALIDA</td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.fecha_salida_rl2
                                  ? queryLaborales.data.fecha_salida_rl2
                                        .split("-")
                                        .reverse()
                                        .join("/")
                                  : ""}
                          </td>
                      </tr>
                  </tbody>
              </table>
              <p className={`mt-2 px-4 py-2 font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                  MOTIVO DE LA SEPARACIÓN
              </p>
              <Controller
                  name="motivo_separacion_rl2"
                  control={control}
                  defaultValue={queryLaborales.data?.motivo_separacion_rl2 || ""}
                  render={({ field }) => (
                      <textarea
                          id="motivo_separacion_rl2"
                          {...field}
                          disabled={true}
                          rows={6}
                          className={`m-2 w-[750px] text-base p-3 border rounded-md ${isDarkMode ? "bg-gray-800 text-gray-200 border-gray-600 placeholder-gray-400" : "bg-white text-gray-800 border-gray-300"}`}
                      />
                  )}
              />
          </div>
          <br />

          {/* Tabla de referencias laborales 3 */}
          <div className={`overflow-x-auto w-full border rounded-lg shadow-md ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
              <table className="min-w-full table-fixed text-left text-sm">
                  <thead className={`${isDarkMode ? "bg-gray-600 text-gray-200" : "bg-gray-200 text-gray-800"}`}>
                      <tr>
                          <th className="w-1/2 px-4 py-2 font-medium">Campo</th>
                          <th className="w-1/2 px-4 py-2 font-medium">Información</th>
                      </tr>
                  </thead>
                  <tbody className={`${isDarkMode ? "text-gray-300" : "text-gray-600"}`}>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">EMPRESA</td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.empresa_rl3}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">DOMICILIO</td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.domicilio_rl3}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">TELÉFONO</td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.telefono_rl3}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">
                              NOMBRE DEL JEFE INMEDIATO
                          </td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.nombre_jefe_rl3}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">
                              PUESTO DEL JEFE INMEDIATO
                          </td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.puesto_jefe_rl3}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">FECHA DE INGRESO</td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.fecha_ingreso_rl3
                                  ? queryLaborales.data.fecha_ingreso_rl3
                                        .split("-")
                                        .reverse()
                                        .join("/")
                                  : ""}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">PUESTO INICIAL</td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.puesto_inicial_rl3}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">SUELDO INICIAL</td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.sueldo_inicial_rl3
                                  ? `$${queryLaborales.data.sueldo_inicial_rl3}`
                                  : ""}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">PUESTO FINAL</td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.puesto_final_rl3}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">SUELDO FINAL</td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.sueldo_final_rl3
                                  ? `$${queryLaborales.data?.sueldo_final_rl3}`
                                  : ""}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">FECHA DE SALIDA</td>
                          <td className="px-4 py-2">
                              {queryLaborales.data?.fecha_salida_rl3
                                  ? queryLaborales.data.fecha_salida_rl3
                                        .split("-")
                                        .reverse()
                                        .join("/")
                                  : ""}
                          </td>
                      </tr>
                  </tbody>
              </table>
              <p className={`mt-2 px-4 py-2 font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                  MOTIVO DE LA SEPARACIÓN
              </p>
              <Controller
                  name="motivo_separacion_rl3"
                  control={control}
                  defaultValue={queryLaborales.data?.motivo_separacion_rl3 || ""}
                  render={({ field }) => (
                      <textarea
                          id="motivo_separacion_rl3"
                          {...field}
                          disabled={true}
                          rows={6}
                          className={`m-2 w-[750px] text-base p-3 border rounded-md ${isDarkMode ? "bg-gray-800 text-gray-200 border-gray-600 placeholder-gray-400" : "bg-white text-gray-800 border-gray-300"}`}
                      />
                  )}
              />
          </div>
      </div>

      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
          <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              REFERENCIAS PERONALES
          </p>
          <p className={`text-lg mb-6 ${isDarkMode ? "text-gray-400" : "text-gray-700"}`}>
              El evaluado manifestó que cuenta con las siguientes referencias
              personales:
          </p>

          {/* Tabla de referencias personales 1 */}
          <div className={`overflow-x-auto w-full border rounded-lg shadow-md ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
              <table className={`min-w-full table-fixed text-left text-sm ${isDarkMode ? "text-gray-300" : "text-gray-600"}`}>
                  <thead className={`${isDarkMode ? "bg-gray-600 text-gray-200" : "bg-gray-200 text-gray-800"}`}>
                      <tr>
                          <th className="w-1/2 px-4 py-2 font-medium">Campo</th>
                          <th className="w-1/2 px-4 py-2 font-medium">Información</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">NOMBRE</td>
                          <td className="px-4 py-2">
                              {queryPersonales.data?.nombre_rp1}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">DOMICILIO</td>
                          <td className="px-4 py-2">
                              {queryPersonales.data?.domicilio_rp1}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">TELÉFONO</td>
                          <td className="px-4 py-2">
                              {queryPersonales.data?.telefono_rp1}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">OCUPACIÓN</td>
                          <td className="px-4 py-2">
                              {queryPersonales.data?.ocupacion_rp1}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">AÑOS DE CONOCERLO</td>
                          <td className="px-4 py-2">
                              {queryPersonales.data?.anios_conocerlo_rp1
                                  ? `${queryPersonales.data.anios_conocerlo_rp1} ${
                                      queryPersonales.data.anios_conocerlo_rp1 === 1
                                          ? "Año"
                                          : "Años"
                                  }`
                                  : ""}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">COMENTARIOS</td>
                          <td className="px-4 py-2">
                              {queryPersonales.data?.comentarios_rp1}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">LO RECOMIENDA</td>
                          <td className="px-4 py-2">
                              {queryPersonales.data?.como_conoce_rp1}
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>

          {/* Tabla de referencias personales 2 */}
          <div className={`overflow-x-auto w-full border rounded-lg shadow-md ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
              <table className={`min-w-full table-fixed text-left text-sm ${isDarkMode ? "text-gray-300" : "text-gray-600"}`}>
                  <thead className={`${isDarkMode ? "bg-gray-600 text-gray-200" : "bg-gray-200 text-gray-800"}`}>
                      <tr>
                          <th className="w-1/2 px-4 py-2 font-medium">Campo</th>
                          <th className="w-1/2 px-4 py-2 font-medium">Información</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">NOMBRE</td>
                          <td className="px-4 py-2">
                              {queryPersonales.data?.nombre_rp2}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">DOMICILIO</td>
                          <td className="px-4 py-2">
                              {queryPersonales.data?.domicilio_rp2}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">TELÉFONO</td>
                          <td className="px-4 py-2">
                              {queryPersonales.data?.telefono_rp2}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">OCUPACIÓN</td>
                          <td className="px-4 py-2">
                              {queryPersonales.data?.ocupacion_rp2}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">AÑOS DE CONOCERLO</td>
                          <td className="px-4 py-2">
                              {queryPersonales.data?.anios_conocerlo_rp2
                                  ? `${queryPersonales.data.anios_conocerlo_rp2} ${
                                      queryPersonales.data.anios_conocerlo_rp2 === 1
                                          ? "Año"
                                          : "Años"
                                  }`
                                  : ""}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">COMENTARIOS</td>
                          <td className="px-4 py-2">
                              {queryPersonales.data?.comentarios_rp2}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">LO RECOMIENDA</td>
                          <td className="px-4 py-2">
                              {queryPersonales.data?.como_conoce_rp2}
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
          <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              REFERENCIAS VECINALES
          </p>
          <p className={`text-lg mb-6 ${isDarkMode ? "text-gray-400" : "text-gray-700"}`}>
              El evaluado manifestó que cuenta con las siguientes referencias
              vecinales:
          </p>

          {/* Tabla de referencias vecinales 1 */}
          <div className={`overflow-x-auto w-full border rounded-lg shadow-md ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
              <table className={`min-w-full table-fixed text-left text-sm ${isDarkMode ? "text-gray-300" : "text-gray-600"}`}>
                  <thead className={`${isDarkMode ? "bg-gray-600 text-gray-200" : "bg-gray-200 text-gray-800"}`}>
                      <tr>
                          <th className="w-1/2 px-4 py-2 font-medium">Campo</th>
                          <th className="w-1/2 px-4 py-2 font-medium">Información</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">NOMBRE</td>
                          <td className="px-4 py-2">{queryVecinales.data?.nombre_rv1}</td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">DOMICILIO</td>
                          <td className="px-4 py-2">
                              {queryVecinales.data?.domicilio_rv1}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">TELÉFONO</td>
                          <td className="px-4 py-2">
                              {queryVecinales.data?.telefono_rv1}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">OCUPACIÓN</td>
                          <td className="px-4 py-2">
                              {queryVecinales.data?.ocupacion_rv1}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">AÑOS DE CONOCERLO</td>
                          <td className="px-4 py-2">
                              {queryVecinales.data?.anios_conocerlo_rv1
                                  ? `${queryVecinales.data.anios_conocerlo_rv1} ${
                                      queryVecinales.data.anios_conocerlo_rv1 === 1
                                          ? "Año"
                                          : "Años"
                                  }`
                                  : ""}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">COMENTARIOS</td>
                          <td className="px-4 py-2">
                              {queryVecinales.data?.comentarios_rv1}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">LO RECOMIENDA</td>
                          <td className="px-4 py-2">
                              {queryVecinales.data?.lo_recomienda_rv1 === null
                                  ? ""
                                  : queryVecinales.data?.lo_recomienda_rv1
                                  ? "Sí"
                                  : "No"}
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>

          {/* Tabla de referencias vecinales 2 */}
          <div className={`overflow-x-auto w-full border rounded-lg shadow-md ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
              <table className={`min-w-full table-fixed text-left text-sm ${isDarkMode ? "text-gray-300" : "text-gray-600"}`}>
                  <thead className={`${isDarkMode ? "bg-gray-600 text-gray-200" : "bg-gray-200 text-gray-800"}`}>
                      <tr>
                          <th className="w-1/2 px-4 py-2 font-medium">Campo</th>
                          <th className="w-1/2 px-4 py-2 font-medium">Información</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">NOMBRE</td>
                          <td className="px-4 py-2">{queryVecinales.data?.nombre_rv2}</td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">DOMICILIO</td>
                          <td className="px-4 py-2">
                              {queryVecinales.data?.domicilio_rv2}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">TELÉFONO</td>
                          <td className="px-4 py-2">
                              {queryVecinales.data?.telefono_rv2}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">OCUPACIÓN</td>
                          <td className="px-4 py-2">
                              {queryVecinales.data?.ocupacion_rv2}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">AÑOS DE CONOCERLO</td>
                          <td className="px-4 py-2">
                              {queryVecinales.data?.anios_conocerlo_rv2
                                  ? `${queryVecinales.data.anios_conocerlo_rv2} ${
                                      queryVecinales.data.anios_conocerlo_rv2 === 1
                                          ? "Año"
                                          : "Años"
                                  }`
                                  : ""}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">COMENTARIOS</td>
                          <td className="px-4 py-2">
                              {queryVecinales.data?.comentarios_rv2}
                          </td>
                      </tr>
                      <tr className={`border-b ${isDarkMode ? "border-gray-600 hover:bg-gray-600" : "border-gray-300 hover:bg-gray-100"}`}>
                          <td className="px-4 py-2 font-semibold">LO RECOMIENDA</td>
                          <td className="px-4 py-2">
                              {queryVecinales.data?.lo_recomienda_rv2 === null
                                  ? ""
                                  : queryVecinales.data?.lo_recomienda_rv2
                                  ? "Sí"
                                  : "No"}
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
          <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              CONDUCTA EN EL EXAMEN
          </p>
          <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              Al momento de realizar la evaluación, mencionó estar en buen estado de
              salud, psicológico y emocional para llevar a cabo la evaluación, por
              lo que durante la entrevista manifestó entender de manera clara y
              oportuna los cuestionamientos que se le realizaron; cabe señalar que
              durante el examen aseveró estar de manera voluntaria asentado su
              consentimiento mediante la firma del formato de autorización, aunado a
              lo anterior acató de manera clara y precisa las indicaciones que se le
              proporcionaron, durante la entrevista se mostró amable y
              participativo, por lo que la prueba se concluyó sin problema alguno.
          </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
          <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>OBSERVACIONES</p>
          {/* Área para agregar notas */}
          <div className="w-full mt-4">
              <Controller
                  name="nota_conclusionvd1"
                  control={control}
                  defaultValue={
                      queryConclusionVD.data && queryConclusionVD.data.length > 0
                          ? queryConclusionVD.data[0].nota_conclusionvd1 || ""
                          : ""
                  }
                  render={({ field }) => (
                      <textarea
                          {...field}
                          onInput={(e) => {
                              const target = e.target as HTMLTextAreaElement;
                              target.style.height = "auto";
                              target.style.height = `${target.scrollHeight}px`;
                          }}
                          placeholder="Escribe tus notas aquí..."
                          className={`w-full border rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 placeholder-gray-400" : "bg-white text-gray-800 border-gray-300 placeholder-gray-500"}`}
                          rows={4}
                      />
                  )}
              />
          </div>
          <div className="grid grid-cols-1 gap-4">
              {/* Campo Resultado */}
              <div className="col-span-1">
                  <Label htmlFor="rfc" className={`text-left ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                      RESULTADO:
                  </Label>
                  <Controller
                      name="resultado1"
                      control={control}
                      defaultValue={
                          queryConclusionVD.data && queryConclusionVD.data.length > 0
                              ? queryConclusionVD.data[0].resultado1 || ""
                              : ""
                      }
                      render={({ field }) => (
                          <input
                              {...field}
                              id="resultado1"
                              type="text"
                              name="resultado1"
                              className={`w-[775px] border rounded-lg p-2 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-800 border-gray-300"}`}
                          />
                      )}
                  />
              </div>
          </div>
      </div>
    </div>
  );

  return (
      <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
        <div className={`container mx-auto p-4`}>
          <form
              className={`max-w-4xl mx-auto rounded-lg shadow-lg overflow-hidden ${isDarkMode ? "bg-gray-800" : "bg-white"}`}
              onSubmit={handleSubmit((data) => {
                  const formData = {
                      ...data,
                      recomendacion: selectedRecommendation,
                      color_se:
                          selectedRecommendation === "recomendable"
                              ? "verde"
                              : selectedRecommendation === "con_reserva"
                              ? "amarillo"
                              : selectedRecommendation === "no_recomendable"
                              ? "rojo"
                              : "",
                  };
                  // Guardar Fecha SE
                  mutateFecha.mutate(
                      {
                          data: { fecha_conclusionvd: data.fecha_conclusionvd },
                          tipo: "put",
                      },
                      {
                          onSuccess: () => {
                              console.log("Fecha guardada con éxito");
                              navigate(`/domiciliaria/${evaluadosList_id}`);
                          },
                          onError: (error) => {
                              console.error("Error al guardar Fecha:", error);
                          },
                      }
                  );

                  // Guardar Semáforo VD
                  mutateSemaforoVD.mutate(
                      {
                          data: formData,
                          tipo: "put",
                      },
                      {
                          onSuccess: () => {
                              console.log("Semáforo VD guardado con éxito");
                              navigate(`/domiciliaria/${evaluadosList_id}`);
                          },
                          onError: (error) => {
                              console.error("Error al guardar Semáforo VD:", error);
                          },
                      }
                  );

                  // Guardar Conclusión
                  mutateConclusionVD.mutate(
                      {
                          data: formData,
                          tipo: "put",
                      },
                      {
                          onSuccess: () => {
                              console.log("Conclusión guardada con éxito");
                              navigate(`/domiciliaria/${evaluadosList_id}`);
                          },
                          onError: (error) => {
                              console.error("Error al guardar Conclusión:", error);
                          },
                      }
                  );
              })}
          >
              {renderHeader()}

              {currentPage === 1 && renderPage1()}
              {currentPage === 2 && renderPage2()}

              <div className="mt-6 p-4 flex justify-between">
                  {currentPage === 1 && (
                      <Button
                          color="red"
                          onClick={() => {
                              window.scrollTo(0, 0);
                              navigate(`/domiciliaria/${evaluadosList_id}`);
                          }}
                          className={`ml-2 ${isDarkMode ? "bg-red-700 text-white hover:bg-red-800" : "bg-red-500 text-white hover:bg-red-600"}`}
                      >
                          Cancelar
                      </Button>
                  )}

                  {currentPage === 1 && (
                      <button
                          type="button"
                          className={`rounded px-4 py-2 ${isDarkMode ? "bg-blue-700 text-white hover:bg-blue-800" : "bg-blue-500 text-white hover:bg-blue-600"}`}
                          onClick={() => {
                              window.scrollTo(0, 0);
                              handlePageChange(currentPage + 1);
                          }}
                      >
                          Siguiente
                      </button>
                  )}

                  {currentPage > 1 && (
                      <Button
                          onClick={() => {
                              window.scrollTo(0, 0);
                              handlePageChange(currentPage - 1);
                          }}
                          className={`${isDarkMode ? "bg-violet-700 text-white hover:bg-violet-900" : "bg-violet-400 text-white hover:bg-violet-600"}`}
                      >
                          Anterior
                      </Button>
                  )}

                  {/* Botón Guardar */}
                  {currentPage === 2 && (
                      <div className="flex space-x-4">
                          <Button
                              type="submit"
                              className={`${isDarkMode ? "bg-green-700 text-white hover:bg-green-800" : "bg-green-500 text-white hover:bg-green-600"}`}
                          >
                              Guardar
                          </Button>
                      </div>
                  )}
              </div>
          </form>
        </div>
      </div>
  );
};
